import { motion } from "framer-motion";
import { BENEFITS } from "@/lib/site";
import { FlaskConical, ShieldCheck, Package, Layers } from "lucide-react";

const icons = [FlaskConical, ShieldCheck, Package, Layers];

export default function BenefitsGrid() {
  return (
    <section id="ciencia" data-testid="benefits-section" className="relative py-20 md:py-28">
      <div className="max-w-[1160px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-16">
          <span className="chip mb-5">
            <span className="dot" /> 4 razones para cambiar
          </span>
          <h2 className="font-display text-3xl md:text-5xl lg:text-[56px] font-bold text-[#0B0B14] tracking-tight leading-[1.05] max-w-4xl mx-auto">
            Por qué las clínicas top de Chile <span className="text-[#5A48C9]">ya cambiaron.</span>
          </h2>
          <p className="mt-5 text-[#3A3A48] max-w-xl mx-auto">
            Cada objeción a cambiar de proveedor, resuelta por escrito. Sin promesas
            verbales.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {BENEFITS.map((b, i) => {
            const Icon = icons[i % icons.length];
            const isHighlight = i === 0 || i === 3;
            return (
              <motion.article
                key={b.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.08 }}
                data-testid={`benefit-${i}`}
                className={`${
                  isHighlight ? "card-glass" : "card-soft"
                } p-8 md:p-10`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-11 h-11 rounded-full bg-white/70 border border-black/[0.06] flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#5A48C9]" strokeWidth={1.7} />
                  </div>
                  <span className="text-[10px] font-semibold uppercase tracking-widest text-[#6B6B7D]">
                    {String(i + 1).padStart(2, "0")} / 04
                  </span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl font-bold text-[#0B0B14] tracking-tight mb-3">
                  {b.title}
                </h3>
                <p className="text-[#3A3A48] text-[15px] leading-relaxed">
                  {b.body}
                </p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
